module.exports = __webpack_public_path__ + "img/loading-logo.2ea94e67.png";